module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/essentials-collection-b94e4093ff713c9e2486baa3667fae4f.jpg";